import React from "react";
import { getAssets } from "@unisearch/helpers";
import {
  LeadSectionHeroForm,
  LeadSectionCounsellingFeatures,
} from "../components";
import styles from "./template.module.scss";

export const LeadTemplateDefault = ({ pageData }) => {
  return (
    <>
      <LeadSectionHeroForm pageData={pageData} />
      <LeadSectionCounsellingFeatures pageData={pageData} />
    </>
  );
};

export default LeadTemplateDefault;
